export function mapEmptyStringToNull(body: any) {
  return JSON.parse(JSON.stringify(body), (_, value) => {
    return typeof value === 'string' && value.trim() === '' ? null : value;
  });
}
